
  import { createRoot } from "react-dom/client";
  import App from "./App.tsx";
  import "./styles/globals.css";
  import "./styles/reveal.css";
  import "highlight.js/styles/github-dark.css";

  createRoot(document.getElementById("root")!).render(<App />);
  